function getTreeDataFromDiagram (diagram) {
  let children = []
  diagram.findTreeRoots().each(n => {
    if (n.data.isGroup) {
      const r = getTreeDataForNode(n)
      if (r !== null) {
        children.push(r)
      }
    } else {
      if (n.data.isIncludedInQuery && n.data.text && n.data.text.trim().length > 0) {
        const c = {
          key: n.data.key,
          text: n.data.text,
          isNegative: n.data.isNegative,
          isOperator: n.data.isOperator,
          ordering: n.data.ordering
        }
        if (n.data.fieldSpecifier) {
          c.fieldSpecifier = n.data.fieldSpecifier
        }
        children.push(c)
      }
    }
  })
  return children
}

function getTreeDataForNode (node) {
  if (node === null || typeof node === 'undefined') {
    return null
  }
  if (node.data.isGroup && node.memberParts && node.memberParts.count <= 0) {
    return null
  }
  if (node.data.isIncludedInQuery === false) {
    return null
  }
  const root = {
    key: node.data.key,
    text: node.data.text,
    children: [],
    operator: node.data.operator,
    isNegative: node.data.isNegative,
    isGroup: node.data.isGroup,
    isOperator: node.data.isOperator,
    ordering: node.data.ordering
  }
  if (node.data.fieldSpecifier) {
    root.fieldSpecifier = node.data.fieldSpecifier
  }
  if (node.memberParts && node.memberParts.count > 0) {
    const x = node.memberParts.iterator
    while (x.next()) {
      const y = getTreeDataForNode(x.value)
      if (y) {
        root.children.push(y)
      }
    }
  }
  if (node.data.isGroup && root.children.length <= 0) {
    return null
  }
  return root
}

export { getTreeDataFromDiagram, getTreeDataForNode }



// WEBPACK FOOTER //
// ./src/graph_parts/tree_data.js